import { gql } from '@apollo/client';

export const GET_LINE_PRIORITY_VALUES = gql`
  query GET_LINE_PRIORITY_VALUES {
    getLineItemPriorityValuesV5
  }
`;
